var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('v-overlay',{attrs:{"value":_vm.loading,"z-index":"9999"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#FB966E","size":"64"}})],1),_c('iframe',{ref:"Iframe",staticClass:"iframe",style:({'border':_vm.border, 'height':_vm.height}),attrs:{"src":_vm.url,"scrolling":_vm.scrolling}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }